<script>
import isEmpty from 'lodash/isEmpty'
export default {
  props: {
    veeName: {
      type: String,
      require: false,
      default: '',
    },
    /**
     * rules vee-validate https://vee-validate.logaretm.com/v2/guide/rules.html
     */
    rules: {
      type: [Object, Boolean],
      require: false,
      default: () => {},
    },
    options: {
      type: Array,
      required: true,
    },
    checked: {
      type: Array,
      require: true,
      default() {
        return []
      },
    },
    name: {
      type: String,
      require: true,
      default: '',
    },
    classCheckbox: {
      type: String,
      require: false,
      default: '',
    },
    custom: Boolean,
    inline: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      trick: this.checked, // hack for vee-validate
      optionsChecked: [],
    }
  },
  computed: {
    isValidate() {
      if (this.rules && !isEmpty(this.rules)) {
        return 'is-valid'
      }
      return ''
    },
    rulesComputed() {
      if (this.rules) {
        return this.rules
      }
      return {}
    },
    computedOptions() {
      const data = this.options.map((option) => {
        if (typeof option !== 'object') {
          return {
            label: option,
            value: option,
            optionDisabled: false,
          }
        } else if (option.disabled) {
          option.optionDisabled = true
        }
        return option
      })
      return data
    },
    groupName() {
      return this.name || 'checkbox' + this._uid
    },
  },
  created() {
    const values = this.options.map((item) => {
      return item.value
    })
    this.optionsChecked = [...this.checked].filter(
      (value) => value !== null && value !== '' && values.includes(value)
    )
  },
  methods: {
    getValidationState({ dirty, validated, valid = null, ...rest }) {
      return dirty || validated ? valid : null
    },
    change(e, option) {
      const index = this.optionsChecked.indexOf(option)
      if (!~index) {
        this.optionsChecked.push(option)
      } else {
        this.optionsChecked.splice(index, 1)
      }
      this.$emit('update:checked', this.optionsChecked, e)
    },
  },
}
</script>

<template>
  <validation-provider
    v-slot="validationContext"
    :rules="rulesComputed"
    :name="veeName"
  >
    <div id="feelline-base-checkbox-group" :class="{ 'form-group': inline }">
      <div :class="(inline ? 'form-inline ' : '') + classCheckbox">
        <CInputCheckbox
          v-for="({ value, label, props, optionDisabled },
          key) in computedOptions"
          :key="key"
          v-model="trick"
          :disabled="disabled || !!optionDisabled"
          :label="label"
          :name="groupName"
          :value="value"
          :checked="checked.includes(value)"
          :custom="custom"
          :inline="inline"
          v-bind="{ ...props, ...$attrs }"
          @change="change($event, value)"
        />
      </div>
      <span class="text-danger">{{ validationContext.errors[0] }}</span>
    </div>
  </validation-provider>
</template>
